"use client";

import { AppLayout } from "@/components/layout/app-layout";
import { BreakBanner } from "@/components/layout/break-banner";
import { usePushSubscription } from "@/hooks/use-push-subscription";
import { usePresenceConnection } from "@/hooks/use-presence-connection";
import { useLivePermissions } from "@/hooks/use-live-permissions";
import { useAgendaSocket } from "@/hooks/use-agenda-socket";
import { InternalUnreadProvider } from "@/hooks/internal-unread-context";
import { TabBadgeProvider } from "@/hooks/tab-badge-context";
import { NotificationsProvider } from "@/hooks/notifications-context";

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // Registra (ou re-registra silenciosamente) Web Push subscription quando
  // o user entra no dashboard. Nao pede permissao automatica — so re-cria
  // subscription se ja foi concedida em sessao anterior. Toggle pra ativar
  // pela primeira vez fica em /dashboard/perfil.
  usePushSubscription();
  usePresenceConnection();
  // Busca /auth/permissions (inclui voiceEnabled) + re-renderiza quando o
  // snapshot muda. Substitui o fetch manual anterior e dá reatividade ao
  // gating da voz (a bolha do webphone aparece/some sem reload).
  useLivePermissions();
  // Avisa o atendente (toast acionavel) quando um callback agendado dispara
  // ou conclui, mesmo fora da tela da agenda.
  useAgendaSocket();

  return (
    <TabBadgeProvider>
    <NotificationsProvider>
    <InternalUnreadProvider>
    <AppLayout>
      <BreakBanner />
      {/* #331: o webphone saiu daqui pro layout RAIZ (`VoiceShell`). Montado
          neste layout, ele era desmontado ao navegar pro wizard de canais, que
          vive em outro grupo de rota — deixando o ramal registrado no motor sem
          nenhuma tela pra atender a ligacao. */}
      {children}
    </AppLayout>
    </InternalUnreadProvider>
    </NotificationsProvider>
    </TabBadgeProvider>
  );
}
